import { render, staticRenderFns } from "./PositionEdit.vue?vue&type=template&id=a08dc9da&scoped=true"
import script from "./PositionEdit.vue?vue&type=script&lang=js"
export * from "./PositionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08dc9da",
  null
  
)

export default component.exports